// extracted by mini-css-extract-plugin
export default {"background":"kJ","weightImage":"lJ","drinkImage":"mJ","content":"nJ","rtbLeft":"oJ","rtbRight":"pJ","rtbLeftMobile":"qJ","imageContainer":"rJ","rtbBox":"sJ","line":"tJ","rtbDesktop":"uJ"};
    if(module.hot) {
      // 1713969934580
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  